import { useEffect, useState, useContext } from 'react';
import { pickBy, identity} from 'lodash'
import Context from '../../container';
import { getSceneInfo } from '../../pages/ai/services';
import { SceneList } from '../../pages/ai/scene';
import Section from '../../pages/ai/section';

export default function SceneSection() {
  const { currentSite = {} } = useContext(Context);
  const [sceneInfo, setSceneInfo] = useState<any>({});

  useEffect(() => {
    if (!currentSite.id) return;
    const params = {
      id: currentSite.id,
    }
    getSceneInfo(pickBy(params, identity)).then((res: any) => {
      setSceneInfo({ ...res, sceneList: Array.isArray(res.sceneList) ? res.sceneList : []})
    });
  }, [currentSite.id]);

  return (
    <Section title={'业务场景在线演示'} description={'全面展示AI原生ERP功能优势与场景实现，助您更快评估落地价值'}>
      <SceneList
        sceneInfo={sceneInfo as any}
        onClearFilter={() => {}}
        selectedFilter={{}}
        setSelectedFilter={() => {}}
        isLandingPage
      />
    </Section>
  );
}